// src/components/Tokenomics.tsx
import React from 'react';
import { Coins, Lock, TrendingUp, Users, Wallet, Shield } from 'lucide-react';

const Tokenomics: React.FC = () => {
  const tokenInfo = {
    totalSupply: '1,000,000,000',
    ticker: 'ALDN',
    tax: '3%',
    decimals: 9,
  };

  

  

  return (
    <section className="py-4 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Tokenomics
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Transparent and sustainable token economics designed for long-term growth
          </p>
        </div>

        {/* Token Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
            <Coins className="w-8 h-8 text-purple-400 mb-3" />
            <div className="text-sm text-gray-400 mb-1">Total Supply</div>
            <div className="text-2xl font-bold">{tokenInfo.totalSupply}</div>
          </div>
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
            <div className="text-purple-400 text-2xl mb-3">🪙</div>
            <div className="text-sm text-gray-400 mb-1">Ticker</div>
            <div className="text-2xl font-bold">{tokenInfo.ticker}</div>
          </div>
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
            <div className="text-purple-400 text-2xl mb-3">%</div>
            <div className="text-sm text-gray-400 mb-1">Transaction Tax</div>
            <div className="text-2xl font-bold text-green-400">{tokenInfo.tax}</div>
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default Tokenomics;